import React from 'react';

import { Markdown } from '~/components';
import { Inner } from '~/styles';

import markdown from './Documents/CommercialDepositAccountAgreement.md';

export const PageCommercialDepositAccountAgreement: React.FC = () => {
  return (
    <>
      <Inner pt={0}>
        <Markdown markdown={markdown} />
      </Inner>
    </>
  );
};
